// Copyright (c) 2022 by Move Closer.

import { Module } from 'vuex'

import { State } from '../shared/contracts/store'

import { AuthState } from './contracts'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const storeFactory = (): Module<AuthState, State> => ({
  namespaced: true,

  state: () => ({
    isUserLoggedIn: null,
    isUserPremium: false,
    isWaitingForAuth: false
  }),

  mutations: {
    SET_IS_USER_LOGGED_IN (state, isUserLoggedIn: AuthState['isUserLoggedIn']) {
      state.isUserLoggedIn = isUserLoggedIn
    },

    SET_IS_USER_PREMIUM (state, isUserPremium: AuthState['isUserPremium']) {
      state.isUserPremium = isUserPremium
    },

    SET_IS_WAITING_FOR_AUTH (state, isWaitingForAuth: AuthState['isWaitingForAuth']) {
      state.isWaitingForAuth = isWaitingForAuth
    }
  },

  getters: {
    isWaitingForAuth: state => state.isWaitingForAuth,
    isUserPremium: state => state.isUserPremium,
    isUserLoggedIn: state => state.isUserLoggedIn
  }
})
